import { render, staticRenderFns } from "./SecondaryNavBar.vue?vue&type=template&id=c8536298&scoped=true&"
import script from "./SecondaryNavBar.vue?vue&type=script&lang=js&"
export * from "./SecondaryNavBar.vue?vue&type=script&lang=js&"
import style0 from "./SecondaryNavBar.vue?vue&type=style&index=0&id=c8536298&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8536298",
  null
  
)

export default component.exports